import ReviewSlider from './js/old/review-slider';
import './scss/old-acf-blocks/review-slider.scss';

new ReviewSlider();
